<template>
  <div class="options-download row  col-md-12 justify-content-end px-0 pb-0 py-0">
    <b-button
      v-if="showOptions.includes('csv')"
      size="sm"
      variant="light"
      class="m-1 align-items-center w-100"
      @click="fallbackClickHandler(downloadCSV)"
    >
      <csv-icon style="font-size: 1.1em; vertical-align: -3%" />
      Baixar CSV
    </b-button>

    <b-button
      v-if="showOptions.includes('xlsx')"
      @click="fallbackClickHandler(downloadXLSX)"

      size="sm"
      variant="light"
      class="m-1 w-100"
    >
      <excel-icon style="font-size: 1.1em; vertical-align: -3%" />
      Baixar XLSX
    </b-button>

    <b-button
      v-if="showOptions.includes('pdf')"
      @click="fallbackClickHandler(downloadPDF)"

      size="sm"
      variant="light"
      class="m-1 w-100"
    >
      <pdf-icon style="font-size: 1.1em; vertical-align: -3%" />
      Baixar PDF
    </b-button>

    <b-button
      v-if="showJson || showOptions.includes('json')"
      @click="fallbackClickHandler(downloadJSON)"

      size="sm"
      variant="light"
      class="m-1 w-100"
    >
      <csv-icon style="font-size: 1.1em; vertical-align: -3%" />
      Baixar Configuração
    </b-button>
  </div>
</template>

<script>
export default {
  props: {
    showJson: {
      required: false,
      default: true
    },
    showOptions: {
      required: false,
      type: Array,
      default: () => ['json', 'csv', 'xlsx', 'pdf']
    },
    downloadCSV: {
      required: false,
      default: null
    },
    downloadXLSX: {
      required: false,
      default: null
    },
    downloadPDF: {
      required: false,
      default: null
    },
    downloadJSON: {
      required: false,
      default: null
    },
  },
  methods: {
    fallbackClickHandler(downloadFunc) {
      return downloadFunc ? downloadFunc() : "";
    },
  }
}
</script>
